import React, { Component } from 'react';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import './LoginForm.scss';
import { signIn } from '../../actions/AuthActions';
import { ConfettiContainer } from '../../components';

class LoginForm extends Component {

  renderError() {
    const { loginError, loginErrorMessage } = this.props;
    if (loginError) {
      return (
        <div className="login-error-wrapper">
          <div className="login-error-box">
            <span>{ loginErrorMessage } </span>
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    const styles = {
      button_style: {
        padding: 2,
        paddingRight: 5,
        backgroundColor: '#2f8ce2',
        marginTop: 20
      }
    };

    return (
      <Card className="main-row">
        <div className="left-background">
          <div className="left-wrapper">
            <span className="l_font_one">Welcome to </span>
            <div className="l_font_two">PRISM</div>
          </div>
        </div>
        <div className="right-background">

          <ConfettiContainer>
            <div className="right-wrapper">
              {this.renderError()}
              <div>
                <span className="r_font_one">A platform for</span><br/>
                <span className="r_font_two">recognition</span>
                <span className="r_font_one">&</span><br/>
                <span className="r_font_three">culture</span>
                <span style={styles.l_font_four}>.</span>
              </div>
              <CardActions align="center">
                <Button size="small" variant="contained" color="primary" style={styles.button_style} onClick={this.props.signIn}>
                  <div className="google-icon" />
                    Sign in with Google.
                </Button>
              </CardActions>
            </div>
          </ConfettiContainer>

        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ authStore }) => {
  const { loginError, loginErrorMessage } = authStore;
  return { loginError, loginErrorMessage };
};

export default connect(mapStateToProps, { signIn })(LoginForm);



// WEBPACK FOOTER //
// ./src/screens/login/LoginForm.js